import {useTranslation} from 'react-i18next'

export const RowHead = () => {
  const {t} = useTranslation()

  return (
    <tr>
      <th>{t('MANAGEMENT_DO_TABLE.COL_SALES_ORG')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_DISTRIBUTOR')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_DISTRIBUTOR_NAME')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_SO_NUMBER')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_DO_NUMBER')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_DELIVERY_ITEM')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_PGI_DATE')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_MATERIAL_NUMBER')}</th>
      <th>{t('Jenis-Produk')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_PLANT')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_PLANT_DESC')}</th>
      <th>{t('MANAGEMENT_DO_TABLE.COL_QUANTITY')}</th>
    </tr>
  )
}
